// import axios from 'axios';
import { jsPDF } from 'jspdf';

export type FileDownloadInfo = {
  url: string;
  fileName: string;
};
export const saveVideoFile = async ({ url, fileName }: FileDownloadInfo, accessToken?: string) => {
  const response = await fetch(url, {
    method: 'GET',
    mode: 'cors',
    credentials: 'omit',
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined
  });

  if (!response.ok) {
    throw new Error(`Network response was not ok. Status: ${response.status}`);
  }
  // const response = await axios.get(url, {
  //   responseType: 'blob',
  //   withCredentials: false,
  //   headers: {}
  // });
  // if (!response) throw new Error('Network response was not ok');
  // const blob = response.data;
  const blob = await response.blob();
  const link = document.createElement('a');

  const objectUrl = URL.createObjectURL(blob);

  link.href = objectUrl;
  link.download = fileName;

  link.click();

  URL.revokeObjectURL(objectUrl);
  link.remove();
};
export const handleDownload = async (imageUrls: string[]) => {
  const pdf = new jsPDF();

  for (let i = 0; i < imageUrls.length; i++) {
    const img = imageUrls[i];
    const imgData = await toBase64(img);

    // Thêm ảnh vào PDF
    if (i > 0) pdf.addPage();
    pdf.addImage(imgData, 'JPEG', 10, 10, 190, 0);
  }

  pdf.save('download.pdf');
};

const toBase64 = (url: string): Promise<string> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = url;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx?.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/jpeg'));
    };
    img.onerror = reject;
  });
